<!-- 拷贝权限 -->
<template>
  <j-modal
    title="设置菜单权限"
    :width="450"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <a-spin :spinning="loading">
      <a-form-model ref="form" :model="form" :rules="rules" @keyup.enter.native="handleOk" layout="vertical">
        <a-form-model-item prop="operation">
          <template slot="label">
            <span>选择要执行的操作</span>
          </template>

          <j-dict-select-tag
            v-model="form.operation"
            :dictCode="[
              { value: 'copy', text: '拷贝权限' },
              { value: 'clear', text: '清除权限' },
            ]"
            type="radio"
          />
        </a-form-model-item>

        <a-form-model-item prop="menuIdFrom" v-if="form.operation == 'copy'">
          <template slot="label">
            <span>拷贝模板</span>
          </template>

          <a-tree-select
            showSearch
            tree-node-filter-prop="title"
            :dropdownStyle="{ maxHeight: 'calc(100vh - 300px)', overflow: 'auto' }"
            :treeData="treeData"
            v-model="form.menuIdFrom"
            placeholder="请选择拷贝模板"
          ></a-tree-select>
        </a-form-model-item>

        <a-form-model-item prop="menuIdTo" v-if="form.operation == 'copy'">
          <template slot="label">
            <span>拷贝至菜单</span>
          </template>

          <a-tree-select
            showSearch
            tree-node-filter-prop="title"
            :dropdownStyle="{ maxHeight: 'calc(100vh - 300px)', overflow: 'auto' }"
            :treeData="treeData"
            v-model="form.menuIdTo"
            placeholder="请选择拷贝至菜单"
          ></a-tree-select>
        </a-form-model-item>

        <a-form-model-item prop="menuIdTo" v-if="form.operation == 'clear'">
          <template slot="label">
            <span>对象菜单</span>
          </template>

          <a-tree-select
            showSearch
            tree-node-filter-prop="title"
            :dropdownStyle="{ maxHeight: 'calc(100vh - 300px)', overflow: 'auto' }"
            :treeData="treeData"
            v-model="form.menuIdTo"
            placeholder="请选择对象菜单"
          ></a-tree-select>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { mixin, mixinDevice } from '@/utils/mixin.js'
import { getAction, deleteAction, postAction } from '@/api/manage'
import { queryTreeList } from '@/api/api'

class formDef {
  operation = 'copy'
  menuIdFrom = undefined
  menuIdTo = undefined
}

export default {
  name: 'MenuAuthModal',
  mixins: [mixin, mixinDevice],
  data() {
    return {
      visible: false,
      loading: false,
      form: new formDef(),
      treeData: [],
      rules: {
        menuIdFrom: [this._r.required],
        menuIdTo: [this._r.required],
      },
      url: {
        setAuth: '/blaze-sys/k00/k0005/MenuManage/setAuth',
      },
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleOpen() {
      queryTreeList({ includeFlow: true }).then((res) => {
        if (res.success) {
          this.treeData = []
          let treeList = res.result.treeList
          for (let a = 0; a < treeList.length; a++) {
            let temp = treeList[a]
            temp.isLeaf = temp.leaf
            this.treeData.push(temp)
          }

          this.visible = true
        }
      })
    },
    handleOk() {
      this.$refs.form.validateFieldsAndScroll((ok) => {
        // 验证成功
        if (ok) {
          if (this.loading) {
            return
          } else {
            this.loading = true
          }

          postAction(this.url.setAuth, this.form)
            .then((res) => {
              if (res.success) {
                this.$message.success('处理成功')
                this.$emit('emit')
                this.visible = false
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>

<style scoped></style>
